import { useMemo } from "react";

import { Blueprint } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";
import { BlueprintSuggestions } from "shared/Blueprint/constants";

import useBlueprintsAnalytics from "../../hooks/useBlueprintsAnalytics";
import useCellCopyAction from "../useCellCopyAction";
import { BLUEPRINTS_COLUMN_ID } from "../constants";
import useCellFilterAction from "../useCellFilterAction";

const BlueprintsTableNameCell = ({
  item: blueprint,
  ...cellProps
}: TableSimpleCellProps<Blueprint>) => {
  const trackAnalytics = useBlueprintsAnalytics();

  const filterAction = useCellFilterAction({
    filterName: BlueprintSuggestions.Name,
    filterValue: blueprint.name,
  });
  const copyAction = useCellCopyAction({
    column: BLUEPRINTS_COLUMN_ID.NAME,
    text: blueprint.name,
  });

  const actions = useMemo(() => [filterAction, copyAction], [filterAction, copyAction]);

  return (
    <TableSimpleCell {...cellProps} role="rowheader" actions={actions}>
      <TableCellLink
        href={`/blueprint/${blueprint.id}`}
        onPress={() => trackAnalytics("Link clicked")}
      >
        {blueprint.name}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default BlueprintsTableNameCell;
